import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import BreadCrumb from "src/Components/GlobalComponents/BreadCrumb";
import ConfirmationModal from "src/Components/GlobalComponents/ConfirmationModal";
import TableWrapper from "src/Components/GlobalComponents/TableWrapper";
import httpRequest from "src/helpers/httpRequest";
import {
  IPharmaInventory,
  IPrescription,
  IPrescriptionDetails,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import deleteIcon from "src/assets/images/delete-icon.png";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { canWrite } from "src/helpers/helperFunctions";
import { CHECKBOX_INPUT, ImageBaseUrl } from "src/lib/constans";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import PrescriptionViewModal from "src/Components/Modals/PrescriptionViewModal";
import moment from "moment";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import { Option } from "react-multi-select-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import PDFDocument from "src/assets/images/website-images/pdf-image.png";
import eyeIcon from "src/assets/images/view.png";

interface IResponce {
  documents: IPrescriptionDetails[];
  paginated: IPaginated;
}

const printStatus = (
  status: string,
  colors: {
    [key: string]: string;
  }
) => {
  return (
    <div
      className={`px-3 py-1 rounded text-white font-size-15px font-Poppins-Medium h-fit lowercase first-letter:capitalize ${colors[status]}`}
    >
      {status === "orderPlaced" ? "Order Placed" : status}
    </div>
  );
};

const Prescriptions: React.FC = () => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const { allIndicators } = useSelector((store: RootState) => store.redDots);
  const hasWriteAccess = canWrite(userDetails, "pharmaInventory", false);

  const [statusLoader, setStatusLoader] = useState<string[] | null>(null);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState<any>(null);
  const [isUpsert, setIsUpsert] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<IPrescription | null>(null);
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState<number>(1);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [allPrescriptions, setallPrescriptions] = useState<
    IPrescriptionDetails[]
  >([]); // State to store the list of products
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 10,
    havePrescription: true,
    status: "",
  });

  // Function to close the delete confirmation modal
  const deleteModalClose = () => {
    setDeleteModal(false);
    setDeleteId("");
  };

  // Function to handle page change in pagination
  const handlePageChange = (e: number) => {
    setQueryParams((prev) => ({
      ...prev,
      page: e,
    }));
  };

  // Function to show the delete confirmation modal and set the ID of the brand to be deleted
  const handleDelete = (id: string) => {
    if (!hasWriteAccess) {
      return;
    }
    setDeleteModal(true);
    setDeleteId(id);
  };

  // API_CALL: Function to delete a product by its ID
  const deleteRequests = async () => {
    setDeleteLoader(true);
    const { res, err } = await httpRequest<any>({
      method: "delete",
      path: `/customer-prescription/delete/${deleteId}`,
      params: {},
    });
    if (res) {
      toast("Prescription deleted successfully.", { type: "success" });
      setQueryParams((prev) => ({
        ...prev,
        bool: !prev.bool,
        page:
          allPrescriptions?.length > 1
            ? prev?.page
            : prev?.page > 1
            ? prev?.page - 1
            : prev?.page,
      }));
      deleteModalClose();
    } else {
      toast(err, { type: "error" });
    }
    setDeleteLoader(false);
  };

  const fetchAllPrescriptions = async () => {
    setIsLoader(true);
    const { bool, ...remainingParams } = queryParams;
    const { res, err } = await httpRequest<IResponce>({
      path: `/customer-prescription/getAll?${qs.stringify(remainingParams)}`,
    });
    if (res) {
      const { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setallPrescriptions(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetchAllPrescriptions();
    setSelectedRows([]);
  }, [queryParams]);

  const handleChangeStatus = async (e: { value: string; label: string }[]) => {
    if (selectedRows.length === 0) {
      toast("Please select at least one prescription", { type: "error" });
      return;
    }
    const { value } = e[0];
    setStatusLoader(selectedRows);
    const { res, err } = await httpRequest<{
      message: string;
      status: boolean;
    }>({
      method: "put",
      path: `/customer-prescription/updateStatus`,
      params: {
        ids: selectedRows,
        status: value,
      },
    });
    if (res) {
      toast("Prescription status updated successfully", { type: "success" });
      fetchAllPrescriptions();
      setSelectedRows([]);
    } else {
      toast(err, { type: "error" });
    }
    setStatusLoader(null);
  };

  const checkForDisabled = (status: string) => {
    let selectedPrescriptions = allPrescriptions.filter((item) =>
      selectedRows.includes(item._id)
    );
    if (statusLoader !== null) {
      return true;
    }
    if (status === "orderPlaced") {
      if (
        selectedPrescriptions.find(
          (item) => item.status !== "pending" && item.status !== "processing"
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (status === "processing") {
      if (selectedPrescriptions.find((item) => item.status !== "pending")) {
        return true;
      } else {
        return false;
      }
    }
    if (status === "declined") {
      if (
        selectedPrescriptions.find(
          (item) => item.status !== "pending" && item.status !== "processing"
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  };

  const statusOptions: Option[] = [
    { label: "Pending", value: "pending", disabled: true },
    {
      label: "Order Placed",
      value: "orderPlaced",
      disabled: checkForDisabled("orderPlaced"),
    },
    {
      label: "Processing",
      value: "processing",
      disabled: checkForDisabled("processing"),
    },
    {
      label: "Declined",
      value: "declined",
      disabled: checkForDisabled("declined"),
    },
  ];

  return (
    <>
      {showPrescriptionModal && (
        <PrescriptionViewModal
          onClose={() => setShowPrescriptionModal(false)}
          data={showPrescriptionModal}
          type={queryParams.havePrescription === true ? "valid" : "nonValid"}
          onReadPrescription={(id) => {
            setShowPrescriptionModal((prev: any) => ({
              ...prev,
              adminNotified: true,
            }));
            let newPrescriptions = allPrescriptions.map((item) => {
              if (item._id === id) {
                return { ...item, adminNotified: true };
              }
              return item;
            });
            setallPrescriptions(newPrescriptions);
          }}
        />
      )}
      <ConfirmationModal
        show={deleteModal}
        onClose={deleteModalClose}
        title="Are you sure you want to delete?"
        leftBtnText="No"
        rightBtnText="Yes"
        onConfirm={deleteRequests}
        loader={deleteLoader}
      />
      <BreadCrumb
        current="Prescriptions"
        previous="dashboard"
        navigateUrl="/admin"
        onPress={() => {
          if (!hasWriteAccess) {
            return;
          }
          setIsEdit(null);
          setIsUpsert((prev) => !prev);
        }}
        btnClassName={`${!hasWriteAccess ? "cursor-not-allowed" : ""}`}
        BtnId="add-prescription-btn"
      />
      <div className="table-container">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 w-full mb-5">
            <PrimaryBtn
              count={allIndicators?.customers_prescribe_valid}
              countShown={true}
              onClick={() =>
                setQueryParams((prev) => ({ ...prev, havePrescription: true }))
              }
              ButtonText="Valid Prescription"
              btnExtraStyle={{
                border: "1px solid",
                backgroundColor:
                  queryParams.havePrescription === true
                    ? "#00443f"
                    : "transparent",
                color:
                  queryParams.havePrescription === true ? "white" : "#00443f",
                borderColor:
                  queryParams.havePrescription === true
                    ? "transparent"
                    : "#00443f",
                padding: "0.5rem 2rem",
              }}
              id="valid-prescription-btn"
            />
            <PrimaryBtn
              count={allIndicators?.customers_prescribe_unvalid}
              countShown={true}
              onClick={() =>
                setQueryParams((prev) => ({ ...prev, havePrescription: false }))
              }
              ButtonText="Non Residence Prescription"
              btnExtraStyle={{
                border: "1px solid",
                backgroundColor:
                  queryParams.havePrescription === false
                    ? "#00443f"
                    : "transparent",
                color:
                  queryParams.havePrescription === false ? "white" : "#00443f",
                borderColor:
                  queryParams.havePrescription === false
                    ? "transparent"
                    : "#00443f",
                padding: "0.5rem 2rem",
              }}
              id="non-residence-prescription-btn"
            />
          </div>
          <div className="flex items-center gap-2">
            <div className="w-fit lg:min-w-[8vw]">
              <CustomWebsiteDropdown
                options={statusOptions.map((v) => ({
                  ...v,
                  disabled: false,
                }))}
                data={statusOptions.filter((v) => v.value === queryParams.status)}
                setData={(e) => {
                  setQueryParams((prev) => ({
                    ...prev,
                    status: e[0]?.value,
                    page: 1,
                  }));
                }}
                placeholder="Filter by Status"
                dropdownMainId="status-filter-dropdown"
                clearId="status-filter-clear"
              />
            </div>
            <div className="w-fit lg:min-w-[8vw]">
              <CustomWebsiteDropdown
                options={statusOptions}
                data={[]}
                readOnly={selectedRows.length === 0}
                setData={handleChangeStatus}
                placeholder="Change Status"
                dropdownMainId="status-dropdown"
                clearId="status-clear"
                disabled={!hasWriteAccess}
              />
            </div>
          </div>
        </div>
        <TableWrapper
          isLoading={isLoader}
          thead={[
            CHECKBOX_INPUT,
            "Prescription",
            "Date Requested",
            "Status",
            "Action",
          ]}
          page={paginated?.currentPage || 1}
          total={paginated?.totalPages || 0}
          columnWidth="5% 57% 15% 13% 10%"
          onChange={handlePageChange}
          selectAll={() =>
            setSelectedRows(allPrescriptions.map((item) => item?._id))
          }
          clearAll={() => setSelectedRows([])}
          selectedRows={selectedRows}
          disabledCheckbox={!hasWriteAccess}
        >
          <div className="tbody-content-height">
            {allPrescriptions.map((item, index: number) => (
              <ul
                key={index}
                className="font-size-16px tbody-light-table font-Poppins-Regular grid"
                style={{
                  gridTemplateColumns: "5% 57% 15% 13% 10%",
                }}
              >
                <li>
                  <input
                    type="checkbox"
                    className="w-4 h-4"
                    disabled={!hasWriteAccess}
                    checked={selectedRows.includes(item?._id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedRows([...selectedRows, item?._id]);
                      } else {
                        setSelectedRows(
                          selectedRows.filter((id) => id !== item?._id)
                        );
                      }
                    }}
                    id={`select-checkbox-${index + 1}`}
                  />
                </li>
                <li>
                  {item?.document ? (
                    item.document.toLowerCase().endsWith(".pdf") ? (
                      <img
                        src={PDFDocument}
                        alt="PDF Document"
                        className={`w-10 h-10 rounded p-0.5 cursor-pointer ${item?.adminNotified === false ? "border-[#00443f] border-2" : "border"}`}
                        onClick={() => window.open(item.document, "_blank")}
                      />
                    ) : (
                      <img
                        src={item.document}
                        alt="Image Document"
                        className={`w-10 h-10 rounded p-0.5 cursor-pointer ${item?.adminNotified === false ? "border-[#00443f] border-2" : "border"}`}
                        onClick={() => window.open(item.document, "_blank")}
                      />
                    )
                  ) : (
                    <span className="text-gray-400">No Document</span>
                  )}
                </li>
                <li className={`${item?.adminNotified === false ? "font-bold" : ""}`}>
                  {item?.createdAt
                    ? moment(item?.createdAt).format("DD/MM/YYYY")
                    : "-"}
                </li>
                <li className="flex items-center !justify-center !pl-0">
                  {item?.status
                    ? printStatus(item?.status, {
                        pending: "bg-[#DCC44B]",
                        orderPlaced: "bg-[#2196F3]",
                        processing: "bg-[#FF9800]",
                        declined: "bg-[#F44336]",
                      })
                    : "-"}
                </li>
                <li className={`action-last-colum`}>
                  <img
                    id={`view-prescription-${index + 1}`}
                    onClick={() => setShowPrescriptionModal(item)}
                    src={eyeIcon}
                    alt="view-prescription"
                    className={`${!hasWriteAccess ? "read_access" : ""}`}
                  />
                  <img
                    id={`delete-prescription-${index + 1}`}
                    onClick={() => handleDelete(item?._id)}
                    src={deleteIcon}
                    alt="delete"
                    className={`${!hasWriteAccess ? "read_access" : ""}`}
                  />
                </li>
              </ul>
            ))}
          </div>
        </TableWrapper>
      </div>
    </>
  );
};

export default Prescriptions;
